module.exports = __webpack_public_path__ + "assets/img/btn-more-0088ae77.png";